export default __webpack_public_path__ + "static/media/PEGASUS_PORTAL_LOGOS-02.65f66e04.png";